import { useState } from 'react'
import { SlideDirection } from './DirectionalSlideSwap'

/**
 * Slide direction state for question transitions (used with DirectionalSlideSwap).
 *
 * Belongs here: slideDirection + startTransition only.
 */
export function useContentTransition() {
  const [slideDirection, setSlideDirection] = useState<SlideDirection>(SlideDirection.Forward)

  function startTransition(direction: SlideDirection) {
    setSlideDirection(direction)
  }

  return { slideDirection, startTransition }
}
